export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getMyNotifications({ rootGetters }, params) {
      return rootGetters.api.get('/user/my-notifications', { params })
        .then((response) => response.data);
    },
    getMyNotificationBody({ rootGetters }, notificationId) {
      return rootGetters.api.post('/user/view-my-notification', {
        notificationId,
      }).then((response) => response.data);
    },
  },
};
